import { WebStorageStateStore } from "oidc-client-ts";

// Azure Entra ID configuration from environment variables
export const AZURE_ENTRA_AUTHORITY = import.meta.env
  .VITE_APP_AZURE_ENTRA_AUTHORITY;
export const AZURE_ENTRA_CLIENT_ID = import.meta.env
  .VITE_APP_AZURE_ENTRA_CLIENT_ID;
export const AZURE_ENTRA_REDIRECT_URL = import.meta.env
  .VITE_APP_AZURE_ENTRA_REDIRECT_URL;

export const AzureEntraAuthConfig = {
  authority: AZURE_ENTRA_AUTHORITY,
  client_id: AZURE_ENTRA_CLIENT_ID,
  redirect_uri: AZURE_ENTRA_REDIRECT_URL,
  response_type: "code",
  scope: `email openid profile api://${AZURE_ENTRA_CLIENT_ID}/access_as_user`,
  // Use localStorage to persist authentication across browser tabs and sessions
  // Tokens remain valid until expiration or explicit logout
  userStore: new WebStorageStateStore({
    store: window.localStorage,
  }),
};
